export const sexAtBirthOptions = [
  { value: "F", label: "Female" },
  { value: "M", label: "Male" },
];

export const relationshipToPolicyHolderOptions = [
  { value: "Self", label: "Self" },
  { value: "Spouse", label: "Spouse" },
  { value: "Significant other", label: "Significant other" },
  { value: "Parent", label: "Parent" },
  { value: "Other", label: "Other" },
];
